var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38149 6L8.8324 1.89987C9.05587 1.69401 9.05587 1.36025 8.83239 1.15439C8.60892 0.948535 8.2466 0.948537 8.02313 1.1544L3.1676 5.62726C2.94413 5.83312 2.94413 6.16688 3.1676 6.37274L8.02313 10.8456C8.2466 11.0515 8.60892 11.0515 8.83239 10.8456C9.05587 10.6398 9.05587 10.306 8.8324 10.1001L4.38149 6Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.51045707.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38149 6L8.8324 1.89987C9.05587 1.69401 9.05587 1.36025 8.83239 1.15439C8.60892 0.948535 8.2466 0.948537 8.02313 1.1544L3.1676 5.62726C2.94413 5.83312 2.94413 6.16688 3.1676 6.37274L8.02313 10.8456C8.2466 11.0515 8.60892 11.0515 8.83239 10.8456C9.05587 10.6398 9.05587 10.306 8.8324 10.1001L4.38149 6Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.51045707.svg";
export { ForwardRef as ReactComponent };